var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavLogoutIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.123 4.30664C10.728 4.36827 11.2002 4.87881 11.2002 5.5C11.2002 6.12119 10.728 6.63173 10.123 6.69336L10 6.7002H6C5.55817 6.7002 5.2002 7.05817 5.2002 7.5V16.5C5.2002 16.9418 5.55817 17.2998 6 17.2998H10C10.6627 17.2998 11.2002 17.8373 11.2002 18.5C11.2002 19.1212 10.728 19.6317 10.123 19.6934L10 19.7002H6C4.23269 19.7002 2.7998 18.2673 2.7998 16.5V7.5C2.7998 5.73269 4.23269 4.2998 6 4.2998H10L10.123 4.30664ZM14.9395 6.93945C15.5252 6.35367 16.4748 6.35367 17.0605 6.93945L21.0605 10.9395C21.6463 11.5252 21.6463 12.4748 21.0605 13.0605L17.0605 17.0605C16.4748 17.6463 15.5252 17.6463 14.9395 17.0605C14.3537 16.4748 14.3537 15.5252 14.9395 14.9395L16.3789 13.5H10.5C9.67157 13.5 9 12.8284 9 12C9 11.1716 9.67157 10.5 10.5 10.5H16.3789L14.9395 9.06055L14.8359 8.94629C14.3558 8.35714 14.3904 7.48848 14.9395 6.93945Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLogoutIco);
export default __webpack_public_path__ + "static/media/Nav_logout_ico.10e7083ad0cd4ea80e5252dab036b1ad.svg";
export { ForwardRef as ReactComponent };